<template>
  <v-row>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 1</v-card-title>
        <v-card-subtitle>
          Click on Manage API Access menu after logining
          <a
            href="https://oanda.com"
            target="blank"
          >oanda.com</a>
        </v-card-subtitle>
        <v-img class="white--text align-end" src="@/assets/brokers/oanda/step1.jpg"></v-img>
      </v-card>
    </v-col>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 2</v-card-title>
        <v-card-subtitle>
          <a href="https://www.oanda.com/account/tpa/personal_token" target="blank">Create new API</a> or Revoke to remove old API.
        </v-card-subtitle>
        <v-img class="white--text align-end" src="@/assets/brokers/oanda/step2.jpg"></v-img>
      </v-card>
    </v-col>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 3</v-card-title>
        <v-card-subtitle>Copy API for next step</v-card-subtitle>
        <v-img class="white--text align-end" src="@/assets/brokers/oanda/step3.jpg"></v-img>
      </v-card>
    </v-col>
    <v-col sm="12" md="4" lg="4">
      <v-card flat>
        <v-card-title>Step 4</v-card-title>
        <v-card-subtitle>Check API and get Account's informations</v-card-subtitle>
        <v-card-text>
          <v-form v-model="valid">
            <v-switch v-model="real" label="Is Real Account?"></v-switch>
            <v-text-field
              v-model="token"
              label="Token"
              :rules="[v => !!v || 'Field is required']"
              clearable
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            outlined
            :loading="loading"
            :disabled="!valid"
            @click="onToken"
          >Check Token & Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { SCHEMA } from "@/store/actions.type";
export default {
  name: "Oanda",
  data() {
    return {
      real: false,
      valid: false,
      token: null,
      loading: false,
      accountIds: [],
      accountDetails: [],
      accounts: []
    };
  },
  watch: {
    accountDetails: function(val) {
      if (val.length == this.accountIds.length) {
        this.convertAccounts(val);
        this.$emit("accounts", this.accounts);
      }
    }
  },
  methods: {
    onToken() {
      // 4c8d34dbcb529def086c87a86bb54d81-49be281b0b815489c728e1b85ff00c6d
      this.loading = !this.loading;
      const oanda = this.axios.create({
        baseURL: this.real
          ? "https://api-fxtrade.oanda.com/v3/"
          : "https://api-fxpractice.oanda.com/v3/",
        headers: {
          Authorization: "Bearer " + this.token
        }
      });
      // check API to get accounts numbers
      oanda.get("accounts").then(res => {
        this.accountIds = res.data.accounts;
        res.data.accounts.forEach(element => {
          oanda.get("accounts/" + element.id).then(accountDetails => {
            this.accountDetails.push(accountDetails.data.account);
          });
        });
      });
    },
    convertAccounts(accounts) {
      this.accounts = [];
      this.$store.dispatch(SCHEMA.GET, "account").then(result => {
        let schema = result.data;
        accounts.forEach(element => {
          let account = Object.assign({}, schema);
          account.broker = "oanda";
          (account.name = element.alias), (account.loginId = element.id);
          account.token = this.token;
          account.live = this.real;
          account.balance = element.balance;
          account.enable = true;
          this.accounts.push(account);
        });
      });
      this.loading = !this.loading;
    }
  }
};
</script>

<style>
</style>